export default "skymp5-front/42061c4161f4d0e2cababe355cc013be.png";